"use strict";
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.btoa = exports.atob = void 0;
const atob = (s) => {
    return Buffer.from(s, 'base64').toString('binary');
};
exports.atob = atob;
const btoa = (s) => {
    return Buffer.from(s).toString('base64');
};
exports.btoa = btoa;
//# sourceMappingURL=base-64-utils.js.map